<!-- src/components/InterviewPage.vue -->
<template>
  <div class="dashboard-root">
    <header class="dashboard-header-bar">
      <div class="dashboard-header-container">
        <div @click="goToHome" class="logo" style="cursor: pointer;">
          <img src="/logo.png" alt="Linkoffer Logo" class="logo-icon" width="32" height="32">
          <span>Linkoffer</span>
        </div>
        <div class="dashboard-actions">
          <div @click="goToHome" class="icon-btn home-btn" title="返回主页" style="cursor: pointer;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3 12l9-8 9 8" stroke="#1890ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 21V12h6v9" stroke="#1890ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
      </div>
    </header>
    <main class="dashboard-content">
      <div class="container">
        <div class="dashboard-title-bar">
          <span class="dashboard-title">面试记录</span>
          <button class="btn btn-blue create-btn" @click="createInterview">创建面试</button>
        </div>
        <div class="dashboard-table-wrapper">
          <table class="dashboard-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>面试名称</th>
                <th>创建时间</th>
                <th>面试时长
                  <span class="help-icon">
                    <svg width="20" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                    <span class="custom-tooltip">
                      如果您没有点击结束面试，则系统将在300分钟后自动结束面试
                    </span>
                  </span>
                </th>
                <th>AI回答次数</th>
                <th>
                  操作
                  <span class="help-icon">
                    <svg width="20" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                    <span class="custom-tooltip">
                      为了保护用户隐私，面试信息仅本地缓存；
                      您可点击下方按钮，获取面试记录(谨慎删除缓存，否则可能无法找回面试记录）
                    </span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in interviewRecords" :key="item.interviewId">
                <td>{{ (pageNum - 1) * pageSize + idx + 1 }}</td>
                <td>{{ item.interviewName }}</td>
                <td>{{ item.createTime }}</td>
                <td>{{ item.totalMinutes }}</td>
                <td>{{ item.agTotalCount }}</td>
                <td>
                  <button class="btn btn-outline-blue btn-action" @click="downloadRecord(item)">面试记录</button>
                  <button class="btn btn-outline-blue btn-action" v-if="item.status === 1" @click="view(item)">返回面试</button>
                </td>
              </tr>
              <tr v-if="interviewRecords.length === 0">
                <td colspan="6" class="empty-tip">暂无面试记录</td>
              </tr>
            </tbody>
          </table>
          <div class="pagination-wrapper">
            <button class="btn btn-outline page-btn" :disabled="pageNum === 1" @click="prevPage">上一页</button>
            <span class="page-info">第 {{ pageNum }} 页 / 共 {{ totalPages }} 页</span>
            <button class="btn btn-outline page-btn" :disabled="pageNum === totalPages" @click="nextPage">下一页</button>
          </div>
        </div>
      </div>
    </main>





      <!-- 设置内容区域高度 -->
      <register
        :dialogRegisterVisible="dialogRegisterVisible"
        @close="dialogRegisterVisible = false"
      ></register>
    <!-- </el-dialog> -->
    <div v-show="false">
      <InterviewPrint
        ref="printRef"
        v-if="printData"
        :info="printData.info"
        :quickCount="printData.quickCount"
        :deepCount="printData.deepCount"
        :durationStr="printData.durationStr"
        :answerRows="printData.answerRows"
      />
      </div>
  </div>
</template>

<script>
import Register from '../views/CreateInterview/CreateInterviewStep1.vue';


import {useStore} from "../store";
import {interviewList, interviewInfo} from "../api/interview";
import InterviewPrint from './InterviewPrint.vue';
import printJS from 'print-js';

export default {
  components: {
    'register': Register,
    InterviewPrint
  },
  created() {
    this.store = useStore();
    this.interviewList();
  },
  data() {
    return {
      store: null, // 全局状态管理
      activeIndex: 1,
      // 注册弹窗标识
      dialogRegisterVisible: false,
      interviewRecords: [
      ],
      totalRecords: 0,
      pageSize: 20,
      pageNum: 1,
      printData: null,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRecords / this.pageSize);
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log('每页显示:', val);
      this.pageSize = val;
      this.pageNum = 1;
      this.interviewList(); // 重新获取数据
    },

    handleCurrentChange(val) {
      console.log('当前页:', val);
      this.pageNum = val;
      this.interviewList(); // 重新获取数据
    },

    // 上一页
    prevPage() {
      if (this.pageNum > 1) {
        this.pageNum--;
        this.interviewList();
      }
    },

    // 下一页
    nextPage() {
      if (this.pageNum < this.totalPages) {
        this.pageNum++;
        this.interviewList();
      }
    },

    // 跳转首页
    goToHome() {
      this.$router.push('/home');
    },

    // 获取用户信息
    async interviewList() {
       // 准备登录信息
      const obj = {pageNum: this.pageNum, pageSize: this.pageSize};
      const response = await interviewList(obj)
      if (response.code === 200) {
         this.interviewRecords = response.data.records; 
         this.totalRecords = response.data.total;

        }
    },
    handleMenuSelect(index) {
      if (index === '1') {
        // this.$router.push('/userInfo');
       const routeUrl = this.$router.resolve({
          name: 'userInfo', // 假设 Homepage 的路由名称为 'Homepage'
          query: { activeIndex: 4 } // 通过 query 参数传递 activeIndex
        })
        window.open(routeUrl.href, '_blank')
      } else if (index === '2') {
        // 退出登录逻辑
        // 退出登录逻辑
        this.store = useStore();
        console.log('store:', this.store);
        console.log('store:', this.store.isLogin);
        this.store.isLogin = false;
        this.$router.push('/home');
        
      }
    },
    changeMenu(index) {
      this.activeIndex = index;
    },
    handleLogin() {
      this.$emit('login');
    },
    handleRegister() {
      this.$emit('register');
    },
    createInterview() {
      // 存在是否有进行中的面试，如果有，则提示用户先结束当前面试
      if(this.interviewRecords.length > 0 && this.interviewRecords.some(item => item.status === 1)) {
        this.$message.error('您有进行中的面试，请先结束当前面试');
        return;
      }
      this.dialogRegisterVisible = true;
      // 创建面试的逻辑
    },
    downloadRecord(row) {
      this.generateInterviewPrint(row);
    },
    async generateInterviewPrint(item) {
      // 1. 获取面试信息
      const interviewId = item.interviewId;
      let infoRes;
      try {
        infoRes = await interviewInfo(interviewId);
      } catch (e) {
        this.$message.error('获取面试信息失败');
        return;
      }
      if (!infoRes || infoRes.code !== 200) {
        this.$message.error('获取面试信息失败');
        return;
      }
      const info = infoRes.data || {};

      // 2. 获取答题历史记录
      const answerRecords = this.store.getAnswerRecordByInterviewId(interviewId);

      // 3. 统计快答/深度思考次数
      let quickCount = 0, deepCount = 0;
      const answerRows = [];
      answerRecords.forEach(record => {
        const question = Object.keys(record)[0];
        const answerObj = record[question] || {};
        if (answerObj.quick) quickCount++;
        if (answerObj.deep) deepCount++;
        answerRows.push([
          question,
          answerObj.quick || '',
          answerObj.deep || ''
        ]);
      });

      // 格式化面试时长
      let durationStr = '';
      if (info.totalMinutes) {
        const min = Math.floor(info.totalMinutes);
        const sec = Math.round((info.totalMinutes - min) * 60);
        durationStr = `${min}分${sec}秒`;
      }

      // 4. 渲染 InterviewPrint 组件并打印
      this.printData = { info, quickCount, deepCount, durationStr, answerRows };
      this.$nextTick(() => {
        printJS({
          printable: 'print-area',
          type: 'html',
          targetStyles: ['*']
        });
      });
    },
    view(val) {
      // 清除IP缓存
      this.clearBoundClientCache();
      // 跳转到面试详情页
      this.$router.push({
        name: 'CreateInterviewStep2',
        query: { interviewId: val.interviewId }
      });
    },
    testPrint() {
      printJS({
        printable: 'print-area',
        type: 'html',
        targetStyles: ['*']
      });
    },

    clearBoundClientCache() {
      localStorage.removeItem('boundClientId');
      console.log('返回面试时IP缓存已清除');
    }
  }
};
</script>

<style scoped>
.dashboard-root {
  min-height: 100vh;
  background: #f6f8fa;
  color: #222;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  font-size: 14px;
}

.dashboard-header-bar {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}

.dashboard-header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-weight: 600;
  font-size: 20px;
}

.logo-icon {
  height: 32px;
  width: 32px;
  margin-right: 8px;
}

.logo-text {
  font-size: 20px;
  font-weight: 600;
  background: linear-gradient(135deg, #2563eb, #60a5fa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.02em;
}

.dashboard-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.icon-btn {
  background: #fff;
  border: 1.5px solid #1890ff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
  padding: 0;
}

.icon-btn:hover {
  background: #e6f7ff;
  border-color: #1765ad;
}

.user-btn svg, .home-btn svg {
  display: block;
  width: 20px;
  height: 20px;
}

.dashboard-content {
  padding-top: 24px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.dashboard-title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.dashboard-title {
  font-size: 1.08rem;
  font-weight: 700;
  color: #1765ad;
  letter-spacing: 0.02em;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
}

.create-btn {
  background: #1890ff;
  color: #fff;
  border: none;
  padding: 10px 32px;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(24,144,255,0.04);
  transition: background 0.3s, transform 0.2s;
  min-width: 120px;
  height: 42px;
}

.create-btn:hover {
  background: #1765ad;
  transform: translateY(-2px);
}

.dashboard-table-wrapper {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.04);
  padding: 18px 12px 8px 12px;
  margin-bottom: 32px;
}

.dashboard-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dashboard-table th, .dashboard-table td {
  padding: 10px 8px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
}

.dashboard-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #1765ad;
  font-size: 13.5px;
  letter-spacing: 0.01em;
  vertical-align: middle;
}

.dashboard-table tr:last-child td {
  border-bottom: none;
}

.btn {
  display: inline-block;
  padding: 5px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  margin: 0 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-blue {
  background: #1890ff;
  color: #fff;
  border: none;
}

.btn-blue:hover {
  background: #1765ad;
}

.btn-action {
  margin: 0 6px;
}

.btn-outline {
  background: #fff;
  color: #1890ff;
  border: 1.5px solid #1890ff;
}

.btn-outline:hover {
  background: #e6f7ff;
  color: #1765ad;
  border-color: #1765ad;
}

.empty-tip {
  color: #aaa;
  font-size: 0.95rem;
  text-align: center;
  padding: 18px 0;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin: 12px 0 0 0;
}

.page-btn {
  min-width: 70px;
}

.page-info {
  font-size: 13px;
  color: #666;
}

.btn-outline-blue {
  background: #fff;
  color: #1890ff;
  border: 1.5px solid #1890ff;
}

.btn-outline-blue:hover {
  background: #e6f7ff;
  color: #1765ad;
  border-color: #1765ad;
}

/* 用户信息样式 */
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border: 1px solid #e5e5e5;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.user-info:hover {
  background: linear-gradient(135deg, #f0f2f5, #ffffff);
  border-color: #d1d5db;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-info iconify-icon {
  color: #2563eb;
}

.username {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 4px;
  min-width: 16px;
  text-align: center;
}

/* 弹窗样式 */
.popover-content {
  padding: 0;
}

.el-menu-vertical-demo {
  border: none;
  background: transparent;
}

.el-menu-item {
  border-radius: 0;
  background: transparent;
  color: #333;
  font-size: 14px;
  padding: 12px 20px;
  transition: all 0.2s ease;
}

.el-menu-item:hover {
  background: linear-gradient(135deg, #f0f2f5, #ffffff);
  color: #2563eb;
  border-radius: 0;
}

.el-menu-item i {
  margin-right: 8px;
  color: inherit;
}

.help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  color: #999;
  cursor: help;
  transition: color 0.2s ease;
  vertical-align: middle;
}

.help-icon:hover {
  color: #1890ff;
}

.help-icon svg {
  width: 14px;
  height: 14px;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .dashboard-header-container {
    padding: 0 16px;
  }
  
  .dashboard-content {
    padding: 20px 0;
  }
  
  .container {
    padding: 0 16px;
  }
  
  .dashboard-title-bar {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .dashboard-title {
    font-size: 1.5rem;
  }
  
  .create-btn {
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
  }
  
  .dashboard-table-wrapper {
    overflow-x: auto;
    margin: 0 -16px;
    padding: 0 16px;
  }
  
  .dashboard-table {
    min-width: 600px;
    font-size: 12px;
  }
  
  .dashboard-table th,
  .dashboard-table td {
    padding: 8px 6px;
    white-space: nowrap;
  }
  
  .btn-action {
    padding: 6px 12px;
    font-size: 12px;
    margin: 2px;
  }
  
  .pagination-wrapper {
    flex-direction: row !important;
    gap: 12px;
    align-items: center;
    justify-content: center;
  }
  
  .page-info {
    font-size: 12px;
  }
  
  .page-btn {
    min-width: 60px;
    padding: 8px 16px;
    font-size: 12px;
  }
  
  .logo span {
    font-size: 16px;
  }
  
  .logo-icon {
    width: 24px;
    height: 24px;
  }
  
  .home-btn {
    padding: 8px;
  }
  
  .home-btn svg {
    width: 20px;
    height: 20px;
  }
  
  .help-icon {
    margin-left: 4px;
    vertical-align: middle;
  }
  
  .help-icon svg {
    width: 12px;
    height: 12px;
  }
  
  .custom-tooltip {
    font-size: 11px;
    padding: 8px 12px;
    max-width: 200px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .dashboard-header-container {
    padding: 0 24px;
  }
  
  .container {
    padding: 0 24px;
  }
  
  .dashboard-table {
    font-size: 13px;
  }
  
  .dashboard-table th,
  .dashboard-table td {
    padding: 10px 8px;
  }
  
  .btn-action {
    padding: 8px 16px;
    font-size: 13px;
  }
  
  .create-btn {
    padding: 12px 24px;
    font-size: 14px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .dashboard-header-container {
    padding: 0 12px;
  }
  
  .container {
    padding: 0 12px;
  }
  
  .dashboard-title {
    font-size: 1.3rem;
  }
  
  .dashboard-table {
    min-width: 500px;
    font-size: 11px;
  }
  
  .dashboard-table th,
  .dashboard-table td {
    padding: 6px 4px;
  }
  
  .dashboard-table th:nth-child(2),
  .dashboard-table td:nth-child(2) {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .btn-action {
    padding: 4px 8px;
    font-size: 11px;
    margin: 1px;
  }
  
  .page-btn {
    min-width: 50px;
    padding: 6px 12px;
    font-size: 11px;
  }
  
  .page-info {
    font-size: 11px;
  }
  
  .logo span {
    font-size: 14px;
  }
  
  .logo-icon {
    width: 20px;
    height: 20px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .dashboard-header-bar {
    height: 50px;
  }
  
  .dashboard-content {
    padding: 15px 0;
  }
  
  .dashboard-title-bar {
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
  
  .dashboard-title {
    font-size: 1.4rem;
  }
  
  .create-btn {
    width: auto;
    padding: 10px 20px;
    font-size: 13px;
  }
  
  .dashboard-table {
    font-size: 12px;
  }
  
  .dashboard-table th,
  .dashboard-table td {
    padding: 6px 8px;
  }
}
</style>